import React from 'react';

const InstagramPosts: React.FC = () => {
    return <div>Instagram Posts</div>;
};

export default InstagramPosts;
export {}; // モジュールとして認識させるための追加